export const VALIDATION_MESSAGES = {
    PASSWORD_BLANK: 'Password cannot be blank',
    PASSWORD_LENGTH: 'Length should be 8-20 characters',
    PASSWORD_TYPE: 'Must contain: 8 characters, Uppercase, Lowercase, Number & Special case',
};
